export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20lifestyle%20shopping%20scene%20with%20fashion%20items%20on%20warm%20cream%20background%2C%20clean%20aesthetic%2C%20gentle%20natural%20lighting%2C%20neutral%20beige%20tones%2C%20editorial%20photography%2C%20elegant%20flat%20lay%20with%20clothing%20accessories%20and%20small%20decorative%20elements%20harmoniously%20arranged%2C%20soft%20shadows%2C%20fresh%20and%20clean%20composition&width=1800&height=800&seq=cta-bg-lifestyle&orientation=landscape"
          alt="CSSBuy Spreadsheet lifestyle shopping"
          title="Shop Smarter with CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col items-start gap-8">
            <p className="text-4xl md:text-6xl lg:text-7xl font-heading text-background-50 leading-none lowercase max-w-xl">
              ready to shop smarter?
            </p>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-background-50 text-foreground-950 font-medium text-sm rounded-full hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Explore KASpreadsheet</span>
              <span className="w-8 h-8 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </span>
            </a>

            <p className="text-sm md:text-base text-background-50/75 leading-relaxed max-w-xs">
              Access hundreds of verified shopping spreadsheets.
              <br />
              Updated daily. Completely free.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}